import type { ReactNode } from 'react';

interface DsKvEntry {
  label: string;
  value: ReactNode;
  prose?: boolean;
  missing?: boolean;
}

interface DsKvProps {
  entries: DsKvEntry[];
  keyWidth?: 80 | 120 | 160;
  className?: string;
}

export function DsKv({ entries, keyWidth = 120, className = '' }: DsKvProps) {
  const widthClass = keyWidth !== 120 ? `k-${keyWidth}` : '';
  const classes = ['ds-kv', widthClass, className].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      {entries.map((entry) => (
        <KvRow key={entry.label} {...entry} />
      ))}
    </div>
  );
}

function KvRow({ label, value, prose, missing }: DsKvEntry) {
  const vClass = ['v', prose && 'prose', missing && 'missing'].filter(Boolean).join(' ');
  return (
    <>
      <span className="k">{label}</span>
      <span className={vClass}>{missing ? '—' : value}</span>
    </>
  );
}
